export function saveBookingPreflightState(
  supabase,
  bookingId,
  preflight
) {
  return supabase.rpc('save_booking_preflight_state', {
    p_booking_id: String(bookingId),
    p_preflight: preflight,
  });
}
